module.exports = Redux;


//////////////////
// WEBPACK FOOTER
// external "Redux"
// module id = 73
// module chunks = 0